const mutations = {
  SET_ALL_CLASSIFICATIONS(localState, payload) {
    //The data for this one comes in a nested format, so this should flatten it into two string arrays
    if (payload && payload.length) {
      for (let i = 0; i < payload.length; i++) {
        const item = payload[i];
        if (Object.prototype.hasOwnProperty.call(item, 'Objective')) {
          localState.objectives.push(item.Objective);
        } else if (Object.prototype.hasOwnProperty.call(item, 'AssetType')) {
          localState.assetTypes.push(item.AssetType);
        }
      }
    }
  }
};

const getters = {
  objectives: localState => localState.objectives,
  assetTypes: localState => localState.assetTypes
};

const state = { objectives: [], assetTypes: [] };

export default {
  mutations,
  state,
  getters
};
